import { registerLanguage } from '../utils-lang';

registerLanguage('French', {
    LOGIN_CANDIDATE_ID_LABEL: 'NIC',
    LOGIN_CANDIDATE_ID_HINT: "Numéro d'identification du candidat",
    LOGIN_PASSWORD_LABEL: 'MDP',
    LOGIN_PASSWORD_HINT: 'Mot de passe du candidat',
    LOGIN_BUTTON: 'Connecter',
});
